<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Support Us">
                    <div>
                        <AmountSelectorList/>                    
                        <ErrorLabel field="amount" />
                        <br/>
                        <ShortNote/>                    
                    </div>
                </FormSection>
                <FormSection v-if="form.amount">
                  <TransactionFee />
                </FormSection>
                <FormSection title="Donation Frequency">
                  <DonationFrequency />
                </FormSection>
                <FormSection title="Your Details">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.yachad.org/privacy-policy/"/>
                  </FormRow> 
                    <FormRow>
                      <FormLabel>
                          <NewsletterSubscribe text="Click here if you want to sign up for our newsletter and receive more information from Yachad." />
                      </FormLabel>
                    </FormRow>   
                    <br/>
                    <InHonorOf />
                </FormSection>                
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                <FormRow>
                  <Receipt />
                </FormRow>                
                </FormSection>
                <PaymentButton showAmount btnText="Donate"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { onMounted } from 'vue'
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import { queryParams } from '~/shared/query-params'

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup(props) {
    const { setValue, form, submit } = usePaymentForm()

    if (props.subCampaign) {
      setValue('applications.0.subCampaign', props.subCampaign)
    }

    onMounted(() => {
      const params = queryParams()

      if (params.utm_content) {
        if (
          !['Direct Mail', 'Telemarketing', 'Text SMS Message'].includes(
            params.utm_content
          )
        ) {
          throw new Error('Invalid subcampaign')
        }

        setValue('applications.0.subCampaign', params.utm_content)
      }
    })

    return {
      form,
      submit,
    }
  },
})
</script>
<style scoped lang="scss">

h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
</style>

